var _path, _path2, _path3, _rect, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWordDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 0C2.89543 0 2 0.89543 2 2V22C2 23.1046 2.89543 24 4 24H20C21.1046 24 22 23.1046 22 22V0H4ZM22 1.57356e-05V4L18 1.53859e-05L22 1.57356e-05Z",
    fill: "#E2E8F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 0V3.99998H22L18 0Z",
    fill: "#94A3B8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8V4H18L22 8Z",
    fill: "#CBD5E1"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 10,
    width: 22,
    height: 10,
    rx: 1,
    fill: "#1D4ED8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3.67969 18H5.79297C7.48047 18 8.44531 16.9648 8.44531 15.1602V15.1523C8.44531 13.3867 7.46875 12.3633 5.79297 12.3633H3.67969V18ZM4.6875 17.1523V13.2109H5.66016C6.76562 13.2109 7.41797 13.9297 7.41797 15.168V15.1758C7.41797 16.4414 6.78125 17.1523 5.66016 17.1523H4.6875ZM12.0312 18.1406C13.6758 18.1406 14.6953 16.9961 14.6953 15.1836V15.1758C14.6953 13.3594 13.6719 12.2227 12.0312 12.2227C10.3945 12.2227 9.36328 13.3594 9.36328 15.1758V15.1836C9.36328 16.9961 10.3789 18.1406 12.0312 18.1406ZM12.0312 17.2695C11.0156 17.2695 10.3906 16.4492 10.3906 15.1836V15.1758C10.3906 13.9023 11.0312 13.0938 12.0312 13.0938C13.0312 13.0938 13.668 13.9023 13.668 15.1758V15.1836C13.668 16.4492 13.0352 17.2695 12.0312 17.2695ZM18.2031 18.1406C19.5039 18.1406 20.4375 17.3867 20.5859 16.2578V16.2305H19.5977L19.5938 16.25C19.4492 16.8711 18.918 17.2695 18.2031 17.2695C17.2422 17.2695 16.6445 16.4688 16.6445 15.1836V15.1758C16.6445 13.8945 17.2422 13.0938 18.1992 13.0938C18.9102 13.0938 19.4492 13.5352 19.5938 14.2031L19.5977 14.2188H20.5859V14.1875C20.4531 13.0352 19.4805 12.2227 18.1992 12.2227C16.6016 12.2227 15.6133 13.3516 15.6133 15.1797V15.1875C15.6133 17.0078 16.6055 18.1406 18.2031 18.1406Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWordDocument);
export default __webpack_public_path__ + "static/media/word-document.eb9797e9582dc8f88a050768a5a19cc5.svg";
export { ForwardRef as ReactComponent };